<div class="row">
    <div class="col-md-12 col-sm-12">
      <div class="card">
        <div class="card-header text-center">
          <h5>LISTA DE PROFORMAS</h5>
        </div>
        <div class="card-header text-center">
          <div class="row">
           <div class="col md-12">
              <h5 class="text-right pr-5">
                <a class="btn btn-info text-white" [routerLink]="['/dashboard/proforma']">
                  Registrar[+]
                </a>
              </h5>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
  
          
            <div class="col-md-12">
              <input
                class="form-control"
                #searchTerm
                (keyup)="search(searchTerm.value)"
                placeholder="Buscar proformas..."
              />
            </div>
          </div>
          <br />
  
          <div *ngIf="pedidos && !orderService.isLoading">
            <table class="table table-condensed table-bordered table-hover table-sm table-md">
              <thead>
                <tr class="text-center">
                  <th>#</th>
                  <th>Num.</th>
                  <th>Estado</th>
                  <th>F. Registro</th>
                  <th>F. Entrega</th>
                  <th>Cliente</th>
                  <th>Vendedor</th>
                  <th>Total</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody *ngFor="let order of pedidos.data; let i = index">
                <tr>
                  <th scope="row" class="text-right">{{ i + 1 + (pedidos.current_page - 1) * pedidos.per_page }}</th>
                  <th>{{ order.proforma_id }}</th>
                  <td class="text-center">
                    <span class="badge badge-info">{{ order.estado }}</span>
                  </td>
                  <td class="text-center">
                    {{ order.fecha | date: 'dd/MM/yyyy' }}
                  </td>
                  <td class="text-center">
                    {{ order.fecha_entrega | date: 'dd/MM/yyyy' }}
                  </td>
                  <td style="width: 180px;">
                    {{ order.cliente.nombres }} {{ order.cliente.apellidos }}
                  </td>
                  <td>
                    {{ order.vendedor.nombres }} 
                  </td>
                  <td style="width: 60px;">
                    {{ order.total }}
                  </td>
                  <td style="width: 200px;">
                   
                                          
                      
                        <span >
                          <a
                            *hasPermission="['administrador', 'almacen']"
                            class="btn btn-warning text-white"
                            [routerLink]="[
                              '/dashboard/proforma-edit',
                              order.proforma_id
                            ]"
                          >
                          <i class="fa fa-edit"></i>
                          </a>
                        </span>
                        <button
                        
                        (click)="showPDF(order.proforma_id)"
                        class="btn btn-primary"
                      >
                        <i class="fa fa-print"></i>
                      </button>
                      <button
                         
                      type="button"
                      (click)="eliminar(order.proforma_id)"
                      class="btn btn-danger"
                    >
                      <i class="fa fa-trash" ></i>
                    </button>
                    <button
                    *ngIf="order.estado == 'PROFORMA'"
                    type="button"
                    (click)="enviar(order.proforma_id)"
                    class="btn btn-success"
                  >
                    <i class="fa fa-send" ></i>
                  </button>
  
                     
                  
                  </td>
                 
                </tr>
              </tbody>
            </table>
            <p>
              Mostrando proformas {{ pedidos.from }} a {{ pedidos.to }} de
              {{ pedidos.total }}
            </p>
            <p>Página {{ pedidos.current_page }} de {{ pedidos.last_page }}</p>
  
            <input type="number" style="width: 50px;"
                [(ngModel)]="paginanum" name="home" required min="0" step="1">
                <button (click)="searchPage(paginanum)" >
                 ir
               </button>
          <br>
  
  
            <button (click)="prevPage()" [disabled]="!pedidos.prev_page_url">
              Anterior
            </button>
            <button (click)="nextPage()" [disabled]="!pedidos.next_page_url">
              Siguiente
            </button>
          </div>
          <p *ngIf="orderService.isLoading">Cargando...</p>
        </div>
      </div>
    </div>
  </div>
  